// Web module: settings. Company info (organization details and settings), users and roles, API keys (agents).
// Routes: /settings -> /settings/users, /settings/company, /settings/users (generic list of users),
// /settings/api-keys.
// The contract is in ../README.md.
import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'
import { appRoute } from '../../app/route-base'
import type { WebModule } from '../../lib/modules'

export const settingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/settings',
  component: lazyRouteComponent(() => import('./SettingsLayout'), 'SettingsLayout'),
})

const settingsIndexRoute = createRoute({
  getParentRoute: () => settingsRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/settings/users' })
  },
})

const companyRoute = createRoute({
  getParentRoute: () => settingsRoute,
  path: 'company',
  component: lazyRouteComponent(() => import('./CompanyPage'), 'CompanyPage'),
})

const usersRoute = createRoute({
  getParentRoute: () => settingsRoute,
  path: 'users',
  component: lazyRouteComponent(() => import('./UsersPage'), 'UsersPage'),
})

const apiKeysRoute = createRoute({
  getParentRoute: () => settingsRoute,
  path: 'api-keys',
  component: lazyRouteComponent(() => import('./ApiKeysPage'), 'ApiKeysPage'),
})

const trainingRoute = createRoute({
  getParentRoute: () => settingsRoute,
  path: 'training',
  component: lazyRouteComponent(() => import('./TrainingPage'), 'TrainingPage'),
})

export const module: WebModule = {
  routes: [
    settingsRoute.addChildren([settingsIndexRoute, companyRoute, usersRoute, apiKeysRoute, trainingRoute]),
  ],
  entityOverrides: {},
}
